
import React, { useEffect, useMemo } from 'react';
import { Tabs, Dropdown, Menu, Space } from 'antd';
import { useLocation, history, useModel } from 'umi';
import type { MenuDataItem } from '@ant-design/pro-layout';
import type { TabsProps } from 'antd';
import styles from './index.less';

type TabItem = {
  key: string;
  label: string;
};

// 路径到标题的映射（用于特殊路径或菜单中找不到的情况）
const pathTitleMap: Record<string, string> = {
  '/system/center': '个人中心',
  '/home': '首页',
  '/product/competitors/detail': '竞品详情',
};

const findTitle = (menu: MenuDataItem[] = [], pathname: string): string | undefined => {
  // 先检查映射表
  if (pathTitleMap[pathname]) {
    return pathTitleMap[pathname];
  }
  
  for (const item of menu) {
    const label = (item as any)?.meta?.title || item.title || item.name;
    if (item.path === pathname) return label || item.path;
    if (item.children) {
      const child = findTitle(item.children as MenuDataItem[], pathname);
      if (child) return child;
    }
  }
  return undefined;
};

const TabsBar: React.FC = () => {
  const location = useLocation();
  const { initialState } = useModel('@@initialState') as { initialState: any };
  const { tabList, activeKey, addTab, closeTab, closeOthers, closeAll, setActiveKey } =
    useModel('tabs');

  // 路由变化时新增或激活标签
  useEffect(() => {
    const title = findTitle(initialState?.menu, location.pathname) || location.pathname;
    addTab({ pathname: location.pathname, title });
  }, [location.pathname, initialState?.menu]);

  const items = useMemo<TabsProps['items']>(() => {
    return tabList.map((tab) => ({
      key: tab.pathname,
      label: tab.title,
      closable: tab.pathname !== '/',
    }));
  }, [tabList]);

  const handleEdit: TabsProps['onEdit'] = (key, action) => {
    if (action === 'remove' && typeof key === 'string') {
      closeTab(key);
    }
  };

  const menu = (
    <Menu
      onClick={(e) => {
        const key = activeKey;
        if (!key) return;
        switch (e.key) {
          case 'closeCurrent':
            closeTab(key);
            break;
          case 'closeOther':
            closeOthers(key);
            break;
          case 'closeAll':
            closeAll();
            history.push('/home');
            break;
          default:
        }
      }}
      items={[
        { key: 'closeCurrent', label: '关闭当前' },
        { key: 'closeOther', label: '关闭其他' },
        { key: 'closeAll', label: '关闭全部' },
      ]}
    />
  );

  return (
    <div className={styles.tabsBar}>
      <div className={styles.tabsLeft}>
        <Tabs
          hideAdd
          type="editable-card"
          size="small"
          items={items}
          activeKey={activeKey}
          onChange={(key) => {
            setActiveKey(key);
            history.push(key);
          }}
          onEdit={handleEdit}
        />
      </div>
      <div className={styles.tabsActions}>
        {/* <Dropdown overlay={menu} placement="bottomRight">
         
        </Dropdown> */}
      </div>
    </div>
  );
};

export default TabsBar;
